import { g as k, a as g, j as e, b as f, s as v } from "./country-de01c755.js";
import { useState as C, useRef as b, useEffect as B, useLayoutEffect as T } from "react";
import { s as o, L as y, u as N, a as P, B as w, c as L, Q as M } from "./index-e7ddceda.js";
import { u as S, b as R, c as U } from "./index-52459974.js";
import "./helper-6945ecce.js";
import { L as F } from "./LoginOpt-7adb4d9a.js";
import { i as d } from "./lib-b7ffbdee.js";
const Q = ({ getStarted: r }) => {
  const n = k("sessionid"), s = S(), i = s.get("referral_code"), l = s.get("invited_source"), [t, p] = C(!1), a = b(null), h = U(), u = window.location.href, m = g(), { logoutRequest: x } = R();
  return B(() => {
    n != null && i && l && !a.current && p(!0);
  }, [i, l, n]), /* @__PURE__ */ e.jsx(e.Fragment, { children: t ? /* @__PURE__ */ e.jsx("div", { className: o.vipUserPromptWrap, children: /* @__PURE__ */ e.jsxs("div", { className: o.vipUserPrompt, children: [
    /* @__PURE__ */ e.jsx("p", { children: r.vipText.promptDesc }),
    /* @__PURE__ */ e.jsxs("div", { className: o.buttonContent, children: [
      /* @__PURE__ */ e.jsx(
        "button",
        {
          className: o.returnButton,
          onClick: (c) => {
            c.preventDefault(), p(!1), a.current = 1, h.push(`/${m}`);
          },
          children: r.vipText.returnHome
        }
      ),
      /* @__PURE__ */ e.jsx(
        "button",
        {
          className: o.exitButton,
          onClick: () => {
            x({
              source: "web"
            }).then(() => {
              f("userKey"), f("sessionid"), p(!1), h.push(u);
            });
          },
          children: r.vipText.signOut
        }
      )
    ] })
  ] }) }) : null });
}, j = {
  "en-US": ["Find Job", "Talk to Boss"],
  "en-us": ["Find Job", "Talk to Boss"],
  "zh-CN": ["找工作", "和老板谈"],
  "zh-cn": ["找工作", "和老板谈"],
  "zh-TW": ["找工作", "和老闆談"],
  "zh-tw": ["找工作", "和老闆談"],
  tr: ["İş bul", "Patronla konuş"],
  "ms-MY": ["Cari kerja", "Bercakap dengan Boss"],
  ms: ["Cari kerja", "Bercakap dengan Boss"],
  "id-ID": ["Mencari pekerjaan", "Bicaralah dengan Bos"],
  id: ["Mencari pekerjaan", "Bicaralah dengan Bos"],
  "ja-JP": ["Find Job", "Talk to Boss"],
  ja: ["Find Job", "Talk to Boss"]
}, z = (r) => {
  const { bannerType: n, dictionary: s } = r, { getStarted: i = {} } = s, l = j[g()] || j["en-US"], t = n == y.neptune;
  return t ? /* @__PURE__ */ e.jsxs("div", { className: o.headerTitle2, children: [
    i == null ? void 0 : i.title,
    " ",
    /* @__PURE__ */ e.jsx("span", { children: t ? "Neptune" : "Bossjob" })
  ] }) : t ? null : /* @__PURE__ */ e.jsx(
    "div",
    {
      style: {
        fontSize: 32,
        fontWeight: 700,
        lineHeight: "110%",
        color: "#121212",
        marginBottom: 44
      },
      children: /* @__PURE__ */ e.jsx("div", { className: o.headerTitle, children: l.join(", ") })
    }
  );
}, H = (r) => {
  const {
    dictionary: n,
    isModal: s = !1,
    handleEmailClick: i,
    handlePhoneClick: l,
    bannerType: t = "2"
  } = r, { getStarted: p = {} } = n, [a, h] = C(!1), u = b(null), m = new URLSearchParams(location.search);
  N(t);
  const x = (c) => {
    h(c), c && u.current.getQrCodeFun();
  };
  return T(() => {
    const c = m.get("redirect");
    c && v("__redirect", c);
  }, [m]), /* @__PURE__ */ e.jsxs("div", { style: d || s ? { width: "100%" } : {
    width: 1024,
    height: 640,
    display: "flex",
    flexDirection: "row",
    padding: 16,
    borderRadius: 16,
    boxShadow: "0px 4px 6px 0px rgba(162, 183, 203, 0.10)"
  }, children: [
    !(d || s) && /* @__PURE__ */ e.jsx("div", { className: o.leftContainer, children: /* @__PURE__ */ e.jsx(P, { dictionary: n, bannerType: t }) }),
    /* @__PURE__ */ e.jsxs(
      "div",
      {
        style: d || s ? {} : {
          flex: 1,
          padding: "20px 34px"
        },
        id: "right-container",
        className: o.rightContainer,
        children: [
          !d && !s && /* @__PURE__ */ e.jsx(
            "div",
            {
              onClick: () => {
                location.href = "/";
              },
              style: {
                position: "absolute",
                top: 20,
                left: 34,
                width: 45,
                height: 45,
                cursor: "pointer"
              },
              children: /* @__PURE__ */ e.jsx(w, {})
            }
          ),
          /* @__PURE__ */ e.jsx(
            L,
            {
              setQrCode: x,
              qrCode: a,
              dictionary: n,
              isModal: s,
              isLeft: !1
            }
          ),
          /* @__PURE__ */ e.jsx("div", { className: a ? o.qrCodeWrapper : "hide", children: /* @__PURE__ */ e.jsx(M, { ref: u, open: a, lang: n }) }),
          /* @__PURE__ */ e.jsxs(
            "div",
            {
              style: {
                marginTop: s ? 54 : 94,
                width: (s || d) && "100%",
                padding: !(s || d) && "0px 66px"
              },
              className: a ? "hide" : o.loginItems,
              children: [
                /* @__PURE__ */ e.jsx(z, { bannerType: t, dictionary: n }),
                /* @__PURE__ */ e.jsx(
                  F,
                  {
                    secondMax: 4,
                    handleEmailClick: i,
                    handlePhoneClick: l,
                    lang: n,
                    isModal: s
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ e.jsx(Q, { getStarted: p })
        ]
      }
    )
  ] });
};
export {
  H as M
};
//# sourceMappingURL=main-5388d86b.js.map
